import { v4 as uuidv4 } from "uuid";
import { uxp } from "../globals";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";

export function useAdobeUserUuidMessage() {
	useListenFromRenderer([
		{
			key: "getAdobeUserUuid",
			onMessage: (message) => {
				const messageId = message.id;
				if (messageId) {
					const adobeUserUuid = uxp.userInfo.userId() as unknown as string;
					postToRenderer([
						{
							key: "adobeUserUuidCallback",
							id: uuidv4(),
							values: {
								messageId,
								adobeUserUuid,
							},
						},
					]);
				}
			},
		},
	]);
}
